import { Head } from "@inertiajs/react"
import { PageHeader } from "@/components/layouts/PageHeader"
import { IntegrationCard } from "@/components/integrations/IntegrationCard"

interface IntegrationProps {
  type: string
  name: string
  description: string
  credential_label: string
  credential_placeholder: string
  credential_help: string
  credential_help_url: string
  status: "connected" | "disconnected"
  connected_at: string | null
  connection_metadata: Record<string, unknown>
}

interface IntegrationsPageProps {
  integrations: IntegrationProps[]
}

export default function Integrations({ integrations }: IntegrationsPageProps) {
  return (
    <>
      <Head title="Integrations" />
      <div className="space-y-6">
        <PageHeader
          title="Integrations"
          description="Connect services to unlock additional source types."
        />

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {integrations.map((integration) => (
            <IntegrationCard key={integration.type} {...integration} />
          ))}
        </div>
      </div>
    </>
  )
}
